$(function () {
  /* バリアント変更時、問診票フォーム内の variant id をメインフォームと同期（未同期だと /cart/add がエラーになる） */
  const productSectionEl = document.querySelector('section[data-section-type="product"]');
  if (productSectionEl) {
    productSectionEl.addEventListener('variant:changed', function (evt) {
      const variant = evt.detail && evt.detail.variant;
      if (!variant) return;
      const idCat1 = productSectionEl.querySelector('#interviewSheet__sku');
      const idCat2 = productSectionEl.querySelector('#interviewSheetCat2__sku');
      if (idCat1) {
        idCat1.value = variant.id;
        if (variant.sku) idCat1.setAttribute('data-sku', variant.sku);
      }
      if (idCat2) {
        idCat2.value = variant.id;
        if (variant.sku) idCat2.setAttribute('data-sku', variant.sku);
      }
    });
  }

  /* 問診票の入力 */
  $("#interviewSheet, #interviewSheet-subscription").click(function () {
    $(".product-cart-form form").find("textarea, :text, select, radio").val("").end().find(":checked").prop("checked", false);
    $(".product-cart-form").addClass("open");
    let quantity = $(".quantity-selector__value").val();
    if ($(this).attr("id") == "interviewSheet-subscription"){
      let subscription_id = $("select[name='subscription'] option:selected").val();
      $('#interviewSheet__selling_plan').attr('name', 'selling_plan');
      $('#interviewSheet__selling_plan').val(subscription_id);
    }else{
      $('#interviewSheet__selling_plan').removeAttr("name");
    }
    $('#interviewSheet__quantity').val(quantity);
  });

  /* 問診票の入力（指定第2類/濫用防止医薬品） */
  $("#interviewSheetCat2, #interviewSheetCat2-subscription").click(function () {
    const form = $(".product-cart-form form");
    form.find("textarea, :text, [type='number'], select").val("");
    form.find(":checked").prop("checked", false);
    // Q3/Q4 の「ある」時のみ表示する備考欄だけを隠す（Q9「症状または目的」は常時表示のため全 textarea を hide しない）
    form.find("#interviewSheetCat2_3_detail, #interviewSheetCat2_4_detail").hide();
    $(".product-cart-form").addClass("open");
    let quantity = $(".quantity-selector__value").val();
    if ($(this).attr("id") == "interviewSheetCat2-subscription"){
      let subscription_id = $("select[name='subscription'] option:selected").val();
      $('#interviewSheetCat2__selling_plan').attr('name', 'selling_plan');
      $('#interviewSheetCat2__selling_plan').val(subscription_id);
    } else {
      $('#interviewSheetCat2__selling_plan').removeAttr("name");
    }
    $('#interviewSheetCat2__quantity').val(quantity);
  });

  /* Cat2 Q3/Q4 備考テキストエリアの表示切替（商品ページ・カートページ共通） */
  $(document).on('change', 'input[name="properties[_ご使用中の医薬品はありますか]"]', function() {
    const textarea = $(this).closest('fieldset').find('textarea');
    if ($(this).val().indexOf('ある') !== -1) {
      textarea.show();
    } else {
      textarea.val('').hide();
    }
  });
  $(document).on('change', 'input[name="properties[_かかっている疾病はありますか]"]', function() {
    const textarea = $(this).closest('fieldset').find('textarea');
    if ($(this).val().indexOf('ある') !== -1) {
      textarea.show();
    } else {
      textarea.val('').hide();
    }
  });

  /* 入力チェック */
  $(".cart-checkForm form, .product-cart-form form").change(function () {
    const inputs = $(this).find('input[type="radio"]');
    const groups = [];
    for (var i = 0; i < inputs.length; ++i) {
      groups.push(inputs[i].name)
    }
    let radio = Array.from(new Set(groups)).length;
    let other_input = $(this).find("textarea:visible").length;
    let other_completed = $(this).find("textarea:visible").filter(function () { return $(this).val(); }).length;
    const attachmentCheck = $(this).find('.js-attachment-confirm');
    const attachmentChecked = attachmentCheck.length === 0 ? true : attachmentCheck.is(':checked');
    if ($(this).find('input[type="radio"]:checked').length == radio && other_input == other_completed && attachmentChecked) {
      $(".form__alert").hide();
      $('.checkForm__footer .cart-recap__checkout, .interviewSheet__footer .product-form__add-button, .interviewSheet__footer .product-form__change-button').removeClass('disabled');
    } else {
      $(".form__alert").show();
      $('.checkForm__footer .cart-recap__checkout, .interviewSheet__footer .product-form__add-button, .interviewSheet__footer .product-form__change-button').addClass('disabled');
    }
  });

	/* 問診票フォーム（main-product のメタフィールドで設問が省略されるため、DOM にある項目だけ必須にする） */
	$(".js-interviewsheet-form form").change(function() {
		let error = false;
		const $form = $(this);

		const hasGender = $form.find('input[name="properties[_使用される方の性別]"]').length > 0;
		const gender = hasGender ? $form.find('input[name="properties[_使用される方の性別]"]:checked').val() : undefined;

		const $ageNumber = $form.find('input[type="number"][name="properties[_使用される方の年齢]"]');
		const ageFromNumber = $form.find('input[type="number"][name="properties[_使用される方の年齢]"]').val();
		const ageFromRadio = $form.find('input[type="radio"][name="properties[_使用される方の年齢]"]:checked').val();
		const age = $ageNumber.length ? ageFromNumber : ageFromRadio;

		const usageMedicine = $form.find('input[name="properties[_ご使用中の医薬品はありますか？]"]:checked').val();
		const usageMedicineDetail = $form.find('textarea[name="properties[_ご使用中の医薬品の詳細]"]').val();

		const hasSymptomBlock = $form.find('input[name="properties[_症状または目的をお選びください]"]').length > 0;
		const condition = hasSymptomBlock ? $form.find('input[name="properties[_症状または目的をお選びください]"]:checked').val() : undefined;
		const diagnosis = $form.find('input[name="properties[_上記の症状に関して、医師の診断はありますか？]"]:checked').val();

		const hasDiseaseBlock = $form.find('input[name="properties[_この他、現在疾病がありますか？]"]').length > 0;
		const disease = hasDiseaseBlock ? $form.find('input[name="properties[_この他、現在疾病がありますか？]"]:checked').val() : undefined;
		const diseaseDetail = $form.find('textarea[name="properties[_疾病の詳細]"]').val();

		const usageHistory = $form.find('input[name="properties[_この薬の使用経験はありますか？]"]:checked').val();
		const sideEffect = $form.find('input[name="properties[_医薬品の副作用経験はありますか？]"]:checked').val();
		const sideEffectDetail = $form.find('textarea[name="properties[_副作用経験の詳細]"]').val();
		const checklistToChemist = $form.find('input[name="properties[_薬剤師への確認・質問事項はありますか？]"]:checked').val();
		const checklistToChemistDetail = $form.find('textarea[name="properties[_薬剤師への確認・質問事項]"]').val();
		const purchaseHistoryAtOtherStore = $form.find('input[name="properties[_最近同じ薬を他店で購入したことがありますか？]"]:checked').val();
		const continuousUse = $form.find('input[name="properties[_この薬を多めに使用、あるいは連用してますか？]"]:checked').val();

		const hasOthersBlock = $form.find('input[name="properties[_以下に当てはまりますでしょうか？]"]').length > 0;
		const applicable = hasOthersBlock ? $form.find('input[name="properties[_以下に当てはまりますでしょうか？]"]:checked').val() : undefined;

		const attachmentCheck = $form.find('.js-attachment-confirm');
		const attachmentConfirmed = attachmentCheck.length === 0 ? true : attachmentCheck.is(':checked');

		if (!usageMedicine) {
			error = true;
		} else if (usageMedicine == "ある" && !usageMedicineDetail) {
			error = true;
		}

		if (hasDiseaseBlock) {
			if (!disease) {
				error = true;
			} else if (disease == "はい" && !diseaseDetail) {
				error = true;
			}
		}

		if (!sideEffect) {
			error = true;
		} else if (sideEffect == "はい" && !sideEffectDetail) {
			error = true;
		}

		if (!checklistToChemist) {
			error = true;
		} else if (checklistToChemist == "はい" && !checklistToChemistDetail) {
			error = true;
		}

		if (hasSymptomBlock) {
			if (!condition) {
				error = true;
			} else if (condition && !diagnosis) {
				error = true;
			}
		}

		if ($ageNumber.length) {
			const n = parseInt(age, 10);
			if (age === "" || age === undefined || isNaN(n) || n < 0 || n > 120) {
				error = true;
			}
		} else if ($form.find('input[type="radio"][name="properties[_使用される方の年齢]"]').length) {
			if (age === undefined || age === "") {
				error = true;
			}
		}

		if (hasGender && !gender) {
			error = true;
		}
		if (!age && age !== 0) {
			error = true;
		}
		if (!purchaseHistoryAtOtherStore || !continuousUse) {
			error = true;
		}
		if (hasOthersBlock && !applicable) {
			error = true;
		}

		if (!attachmentConfirmed) {
			error = true;
		}

		if (error) {
			$(".form__alert").show();
			$(".js-interviewsheet-submit").addClass('disabled');
		} else {
			$(".form__alert").hide();
			$(".js-interviewsheet-submit").removeClass('disabled');
		}

	});

  /* 閉じるボタン */
  $("button.close-modal").click(function () {
    $(".cart-checkForm, .product-cart-form").removeClass("open");
  });

  /* 問診票の変更 */
  $(".editForm").click(function () {
    let target = $(this).attr("name");
    $("#"+target).toggleClass("open");
  });
  $(".product-form__change-button").click(function () {
    let line_item = $(this).attr("data-line");
    let line_quantity = $(this).attr("data-quantity");
    const form_data = $(this).parents("form").serializeArray();
    const line_properties = {};
    for (key in form_data) {
      line_properties[form_data[key].name.replace(/^.+\[|\]/g, "")] = form_data[key].value;
    }
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {
        line: line_item,
        quantity: line_quantity,
        properties: line_properties
      },
      dataType: 'json',
    }).success(function (data) {
      location.reload();
    }).error(function (data) {
      location.reload();
    });
  });

  /* 問診票の確認 */
  $("#checkForm").click(function () {
    $(".cart-checkForm").addClass("open");
  });
});

const isWebViewOnMobileApp = () => {
  var webviewParams = window.sessionStorage.getItem('WEB_VIEW_AUTH_PARAMS') || '';
  if (!webviewParams) return false;
  try {
    return !!JSON.parse(webviewParams)['isWebView']
  } catch {
    return false;
  }
}

const autoRedirectForMobileApp = (screen) => {
  if (!window.appNavigation) return;

  var returnTo = window.location.pathname;
  var url = new URL(window.location.href);
  var params = url.searchParams;

  var prevPathname = document.referrer ? new URL(document.referrer).pathname : '';

  // チェックアウトページからログアウトした場合、ホーム遷移
  // チェックアウトページからログアウトした事を明確に検知することはできないためこの条件で対応
  if (prevPathname === '/') {
    window.appNavigation.postMessage('logout');
    return;
  }

  // NOTE: 相対パスが入っている想定
  if (params.get('checkout_url')) {
    returnTo = encodeURIComponent(params.get('checkout_url'));
  }

  window.appNavigation.postMessage(`push:/${screen}?store_type=otc&return_to=${returnTo}`);
}

$('a[href$="/account/logout"]').click(function (e) {
  if (!isWebViewOnMobileApp()) return;
  if (!window.appNavigation) return;

  e.preventDefault();
  window.appNavigation.postMessage('logout');
});
